import styled from 'styled-components';
import { forceBreakTextCss } from '../styles';
export const Header = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    justify-content: ${(props) => props.theme.align === 'CENTER' ? 'center' : 'space-between'};

    &.avatar-present {
        justify-content: space-between;
    }

    text-align: ${(props) => props.theme.align.toLowerCase()};

    @media (max-width: 362px) {
        justify-content: ${(props) => props.theme.align === 'CENTER' && 'center'};

        text-align: ${(props) => props.theme.align === 'CENTER' && 'center'};
    }

    > div.title {
        ${forceBreakTextCss};
        text-align: left;

        h3 {
            display: inline-block;
            width: 186.59px;
        }
    }

    .title.full-width {
        h3 {
            width: 100%;
        }
    }

    > div.avatar {
        &.full-width {
            display: flex;
            justify-content: ${(props) => props.theme.align === 'CENTER' && 'center'};

            text-align: ${(props) => props.theme.align === 'CENTER' && 'center'};
            width: 100%;
        }
    }
`;
export const Avatar = styled.div `
    border-radius: 50%;
    width: 96px;
    height: 96px;
    background-size: cover;
    background-position: center;
    background-image: url(${(props) => props.$logo});
`;
export const Content = styled.div `
    ${forceBreakTextCss};
    h5 {
        font-style: normal;
        font-weight: normal;
    }

    h5,
    h1 {
        display: inline-block;
        white-space: pre-line;
    }

    h5 {
        font-weight: normal;
    }

    .supporting-text.mt {
        margin-top: 16px;
    }
`;
export const ButtonContainer = styled.div `
    display: flex;
    justify-content: ${(props) => props.theme.align.toLocaleLowerCase()};
`;
